import { render } from "./GridNomenclatorPam.vue?vue&type=template&id=2d281697&scoped=true&ts=true"
import script from "./GridNomenclatorPam.vue?vue&type=script&lang=ts"
export * from "./GridNomenclatorPam.vue?vue&type=script&lang=ts"

import "./GridNomenclatorPam.vue?vue&type=style&index=0&id=2d281697&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d281697"]])

export default __exports__